import React from 'react';
import './backfillcheck.css';

export default function BackFillCheck({ openBackFillPopup, closeBackFillPopup }) {
  return (
    <div className="bfc-wrap">
      <h4 className="bfc-title">When would you like your session?</h4>
      <p className="bfc-sub">Choose an option that works best for you.</p>

      <div className="bfc-cards">
        {/* Start now */}
        <div className="bfc-card bfc-card--active">
          <div className="bfc-card-top">
            <div className="bfc-icon-wrap">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d5a67b" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
              </svg>
            </div>
            <div className="bfc-card-body">
              <p className="bfc-card-title">I’m Ready Now</p>
              <p className="bfc-card-desc">See if a Medium is available right away.</p>
              <span className="bfc-badge bfc-badge--green">
                <span className="bfc-badge-dot bfc-badge-dot--green" />
                Usually in minutes
              </span>
            </div>
          </div>
          <button className="bfc-btn bfc-btn--solid" onClick={openBackFillPopup}>
            Find a Medium Now
          </button>
        </div>

        {/* "OR" divider between the two options */}
        <div className="bfc-or-line" aria-hidden="true" />
        <div className="bfc-or-badge" aria-hidden="true">OR</div>

        {/* Book in advance */}
        <div className="bfc-card">
          <div className="bfc-card-top">
            <div className="bfc-icon-wrap bfc-icon-wrap--gray">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </div>
            <div className="bfc-card-body">
              <p className="bfc-card-title bfc-card-title--dark">Book for Future</p>
              <p className="bfc-card-desc">Pick a date and time that works for you.</p>
              <span className="bfc-badge bfc-badge--tan">
                <span className="bfc-badge-dot bfc-badge-dot--tan" />
                Plan ahead
              </span>
            </div>
          </div>
          <button className="bfc-btn bfc-btn--outline" onClick={closeBackFillPopup}>
            Schedule a Session
          </button>
        </div>
      </div>
    </div>
  );
}
